/**
 * `/w/:slug/assinatura` — a tela que o item "Assinatura" do menu promete.
 *
 * O conteúdo é o mesmo componente da aba "Plano" das configurações
 * (`PlanoDoWorkspace`): uma lógica só, dois caminhos até ela. Duas ENTRADAS
 * para a mesma tela é comodidade; duas CÓPIAS da mesma tela é como uma delas
 * envelhece sem ninguém notar — e por isso não existe nenhuma cópia aqui.
 *
 * Esta rota é a que aparece na barra inferior do celular e na sidebar; a aba
 * dentro de Configurações é para quem já está mexendo em workspace e equipe.
 */
import { PageHeader } from '@mgdlead/ui';
import { PlanoDoWorkspace } from '../../../features/billing/PlanoDoWorkspace';
import { useWorkspace } from '../../../features/workspace/WorkspaceContext';
import { useDocumentTitle } from '../../../lib/useDocumentTitle';

export function PlanPage() {
  const { workspace } = useWorkspace();
  useDocumentTitle('Assinatura');

  return (
    <>
      <PageHeader
        title="Assinatura"
        description={`Plano, vencimento e quanto ${workspace.name} já usa de cada limite.`}
      />
      <PlanoDoWorkspace />
    </>
  );
}
